var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){return _vm.toggleAnswer('yes')}}},[_vm._v("Yes")]),_c('button',{on:{"click":function($event){return _vm.toggleAnswer('no')}}},[_vm._v("No")])])}
var staticRenderFns = []

export { render, staticRenderFns }